// extracted by mini-css-extract-plugin
export default {"optionsContainer":"form_optionsContainer__EkHd-"};